<template>
  <div class="big-screen" id="bigScreen">
    <div
      class="canvas-wrap"
      @dblclick.stop="doFullScreen"
      id="canvasWrap"
    ></div>
    <div class="maskDebug" v-if="showMask"></div>
    <span
      class="fullScreen"
      v-if="!showMask"
      :class="{ show: !fullScreen }"
      @click.stop="doFullScreen"
      >{{ !fullScreen ? "全屏" : "取消全屏" }}</span
    >
  </div>
</template>
<script>
import { API_BASE_URL } from "./../../urlConfig/index";
export default {
  name: "bigScreen",
  props: ["curStoreId"],
  data() {
    return {
      showFullScreen: true,
      showMask: false,
      noData: true,
      coverImgMaxSize: 15 * 1024 * 1024, // 图片最大字节数
      sites: [],
      activeNames: ["1"],
      showDrawer: false,
      form: {
        background: "",
        computerNodeType: "computer",
        computerNodeSize: 70,
        canvasJsonText: "",
        extra: [],
      },
      options: [
        {
          label: "文本式",
          value: "text",
        },
        {
          label: "电脑图标式",
          value: "computer",
        },
      ],
      computerObj: {
        ip: "192.168.0.1",
        status: "free",
        name: "001",
        offset: {
          x: 0,
          y: 0,
          rotation: 0,
          skewX: 0,
          skewY: 0,
        },
      },
      stageWidth: "",
      stageHeight: "",
      stage: null,
      layer: null,
      computerLayer: null,
      contextMenuNode: null,
      rollComputer: null,
      container: null,
      nowSelGroup: null,
      delta: 1,
      numsInfo: [],
      computers: [],
      deskStatus: {
        0: "free",
        1: "busy",
        2: "book",
      },
      fullScreen: false,
    };
  },
  methods: {
    doFullScreen() {
      if (!this.fullScreen) {
        const docElm = document.documentElement;
        if (docElm.requestFullscreen) {
          this.fullScreen = true;
          docElm.requestFullscreen();
        }
      } else {
        if (document.exitFullscreen) {
          this.fullScreen = false;
          document.exitFullscreen();
        }
      }
    },
    createStage() {
      const bigScreenEle = document.querySelector("#canvasWrap");
      this.stageWidth = bigScreenEle.clientWidth;
      console.log("stageWidth", this.stageWidth);
      this.stageHeight = bigScreenEle.clientHeight;
      this.stage = new Konva.Stage({
        container: "canvasWrap",
        width: this.stageWidth,
        height: this.stageHeight,
      });
      this.layer = new Konva.Layer();
      this.computerLayer = new Konva.Layer();
      this.computerDrawLayer = new Konva.Layer();
      this.extraDrawLayer = new Konva.Layer();
      this.extraDrawLayerForImage = new Konva.Layer();
      this.stage.add(this.layer);
      this.stage.add(this.computerLayer);
      this.stage.add(this.computerDrawLayer);
      this.stage.add(this.extraDrawLayerForImage);
      this.stage.add(this.extraDrawLayer);
      this.stage.on("contextmenu", (e) => {
        e.evt.preventDefault();
      });
      //
      console.log("bgurl",this.form.background)
      //
      Konva.Image.fromURL(this.form.background, (darthNode) => {
        darthNode.setAttrs({
          x: 0,
          y: 0,
          width: this.stage.width(),
          height: this.stage.height(),
          keepRatio: true,
        });
        this.computerLayer.add(darthNode);
        this.computerLayer.batchDraw();
        this.computerLayer.on("click", (event) => {
          event.cancelBubble = true;
          if (this.rollComputer) {
            this.rollComputer.stopTransform();
            this.rollComputer.hide();
          }
        });
      });
      //
      this.container = this.stage.container();
      this.container.addEventListener("dragover", (e) => {
        e.preventDefault();
      });
      this.container.addEventListener("drop", (e) => {
        e.preventDefault();
        this.stage.setPointersPositions(e);
        let url = `/static/bigScreen/assets/computer_free.png`;
        if (this.form.computerNodeType == "text") {
          url = `/static/bigScreen/assets/computer_free_text.png`;
        }
        console.log(this.stage.getPointerPosition());
        const stagePointerPosition = this.stage.getPointerPosition();
        this.$set(this.computerObj.offset, "x", stagePointerPosition.x - 16);
        this.$set(this.computerObj.offset, "y", stagePointerPosition.y - 16);
        if (!this.computerObj.ip) {
          this.$message({ customClass: "error", message: "此机位已添加" });
          return;
        }
        let computers = localStorage.getItem("computers");
        if (computers && Array.isArray(JSON.parse(computers))) {
          computers = JSON.parse(computers);
          computers.push(this.computerObj);
        } else {
          computers = [];
          computers.push(this.computerObj);
        }
        this.$set(this, "computers", computers);
        localStorage.setItem("computers", JSON.stringify(computers));
        this.drawComputer(
          this.computerObj,
          "/static/bigScreen/assets/computer_free_text.png"
        );
      });
      this.container.tabIndex = 1;
      this.container.focus();
      this.container.addEventListener("keydown", (e) => {
        console.log(this.nowSelGroup);
        if (e.keyCode === 37) {
          this.nowSelGroup.x(this.nowSelGroup.x() - this.delta);
        } else if (e.keyCode === 38) {
          this.nowSelGroup.y(this.nowSelGroup.y() - this.delta);
        } else if (e.keyCode === 39) {
          this.nowSelGroup.x(this.nowSelGroup.x() + this.delta);
        } else if (e.keyCode === 40) {
          this.nowSelGroup.y(this.nowSelGroup.y() + this.delta);
        } else {
          return;
        }
        e.preventDefault();
      });
      //
      let extra = [];
      if (this.form.hasOwnProperty("extra")) {
        const form = JSON.parse(JSON.stringify(this.form));
        extra = form.extra;
      }
      setTimeout(() => {
        this.computers.forEach((it) => {
          // let url = `/static/bigScreen/assets/computer_${it.status}.png`;
          // if (this.form.computerNodeType == "text") {
          //   url = `/static/bigScreen/assets/computer_${it.status}_text.png`;
          // }
          // this.drawComputer(it, url);
          this.drawComputer(
            it,
            "/static/bigScreen/assets/computer_free_text.png"
          );
        });
        //
        if (extra && Array.isArray(extra)) {
          extra.forEach((it) => {
            // if (it.type == "text") {
            this.createExtra(it.type, it);
            // }
          });
        }
        //
      }, 599);
    },
    createExtra(type, obj, init = false) {
      if (type == "text") {
        const text = new Konva.Text({
          uuidName: obj.uuidName ? obj.uuidName : this.$uuid.create(1).hex,
          x: obj.offset.x,
          y: obj.offset.y,
          rotation: obj.offset.rotation,
          skewX: obj.offset.skewX,
          skewY: obj.offset.skewY,
          scaleX: obj.offset.scaleX,
          scaleY: obj.offset.scaleY,
          text: obj.content,
          fontSize: obj.fontSize,
          fill: obj.fill,
        });
        this.extraDrawLayer.add(text);
      } else if (type == "image") {
        Konva.Image.fromURL(obj.path, (darthNode) => {
          darthNode.setAttrs({
            uuidName: obj.uuidName ? obj.uuidName : this.$uuid.create(1).hex,
            path: obj.path,
            x: obj.offset.x,
            y: obj.offset.y,
            width: obj.offset.width,
            height: obj.offset.height,
            rotation: obj.offset.rotation,
            skewX: obj.offset.skewX,
            skewY: obj.offset.skewY,
            scaleX: obj.offset.scaleX,
            scaleY: obj.offset.scaleY,
            keepRatio: true,
          });
          this.extraDrawLayerForImage.add(darthNode);
        });
      }
    },
    drawComputer(it, url) {
      const group = new Konva.Group({
        width: 32,
        height: 32,
        keepRatio: true,
        x: (it.offset.x / 1920) * this.stageWidth,
        y: (it.offset.y / 1080) * this.stageHeight,
        rotation: it.offset.rotation,
        name: it.ip,
        scale: {
          x: this.form.computerNodeSize / 100,
          y: this.form.computerNodeSize / 100,
        },
        skewX: it.offset.skewX ? it.offset.skewX : 0,
        skewY: it.offset.skewY ? it.offset.skewY : 0,
      });
      let fillColor = "#333";
      if (it.status == "free") {
        fillColor = "#333";
      } else if (it.status == "book") {
        fillColor = "#ff9f4c";
      } else if (it.status == "busy") {
        fillColor = this.form.computerFillColor;
      }
      Konva.Image.fromURL(url, (darthNode) => {
        darthNode.setAttrs({
          x: 0,
          y: 0,
          width: 32,
          height: 27,
          fill: fillColor,
        });
        let simpleText = new Konva.Text({
          x: 16,
          y: 7,
          align: "center",
          // text: it.name,
          text: parseInt(it.name),
          fontSize: 16,
          // fontFamily: "Calibri",
          fill: this.form.computerTextColor,
        });
        simpleText.offsetX(simpleText.width() / 2);

        group.add(darthNode);
        group.add(simpleText);
        this.computerDrawLayer.batchDraw();
      });
      this.computerDrawLayer.add(group);
    },
    computedIpNo(ip) {
      let tempIp = ip.trim();
      const ipArr = tempIp.split(".");
      return ipArr[ipArr.length - 1];
    },
    getScreenDetail() {
      return new Promise((resolve, reject) => {
        this.$http({
          url: "map/detail",
          method: "GET",
          params: {
            storeId: this.curStoreId,
          },
        })
          .then((res) => {
            console.log(res);
            if (res.data) {
              this.noData = false;
              try {
                if (res.data.h5JsonText) {
                  let jsonText = JSON.parse(res.data.h5JsonText);
                  if (jsonText.hasOwnProperty("computerFillColor")) {
                    this.form = jsonText;
                  } else {
                    this.form = jsonText;
                    this.form.computerFillColor = "#e66a6a";
                  }
                  if (!jsonText.hasOwnProperty("computerTextColor")) {
                    this.form.computerTextColor = "#fff";
                  }
                  this.$forceUpdate();
                  if (jsonText.hasOwnProperty("canvasJsonText")) {
                    if (this.numsInfo && Array.isArray(this.numsInfo)) {
                      if (Array.isArray(jsonText.canvasJsonText)) {
                        this.numsInfo.forEach((it) => {
                          jsonText.canvasJsonText.forEach((ite) => {
                            if (ite.ip == it.ipAddress) {
                              ite.status = this.deskStatus[it.status];
                            }
                          });
                        });
                        this.computers = jsonText.canvasJsonText;
                      }
                    }
                  }
                  console.log(this.form);
                  console.log(this.computers);
                  setTimeout(() => {
                    this.createStage();
                  }, 100);
                }
              } catch (error) {
                console.log(error);
              }
            } else {
              this.noData = true;
              try {
                let jsonText = localStorage.getItem("jsonText");
                if (jsonText) {
                  jsonText = JSON.parse(jsonText);
                  this.form = jsonText;
                  if (jsonText.hasOwnProperty("canvasJsonText")) {
                    if (this.numsInfo && Array.isArray(this.numsInfo)) {
                      if (Array.isArray(jsonText.canvasJsonText)) {
                        this.numsInfo.forEach((it) => {
                          jsonText.canvasJsonText.forEach((ite) => {
                            if (ite.ip == it.ipAddress) {
                              ite.status = this.deskStatus[it.status];
                            }
                          });
                        });
                        this.computers = jsonText.canvasJsonText;
                      }
                    }
                  }
                  console.log(this.form);
                  this.$nextTick(() => {
                    this.createStage();
                  });
                }
              } catch (error) {
                console.log(error);
              }
            }
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    isMobile() {
      let userAgentInfo = navigator.userAgent;
      let Agents = new Array(
        "Android",
        "iPhone",
        "SymbianOS",
        "Windows Phone",
        "iPad",
        "iPod"
      );
      let flag = true;
      for (let v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
          flag = false;
          break;
        }
      }
      return flag;
    },
    getPar() {
      return new Promise((resolve, reject) => {
        this.$http({
          url: "region/list",
          method: "POST",
          data: {
            storeId: this.curStoreId,
          },
        })
          .then((res) => {
            let nums = [];
            if (res.data && Array.isArray(res.data)) {
              res.data.forEach((it) => {
                if (Array.isArray(it.nums)) {
                  nums = nums.concat(it.nums);
                }
              });
            }
            console.log("nums", nums);
            this.numsInfo = nums;
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    rollPar() {
      this.$http({
        url: "region/list",
        method: "POST",
        data: {
          storeId: this.curStoreId,
        },
      }).then((res) => {
        let nums = [];
        if (res.data && Array.isArray(res.data)) {
          res.data.forEach((it) => {
            if (Array.isArray(it.nums)) {
              nums = nums.concat(it.nums);
            }
          });
        }
        this.numsInfo = nums;
        let computers = JSON.parse(JSON.stringify(this.computers));
        if (this.numsInfo && Array.isArray(this.numsInfo)) {
          if (Array.isArray(computers)) {
            this.numsInfo.forEach((it) => {
              computers.forEach((ite) => {
                if (ite.ip == it.ipAddress) {
                  ite.status = this.deskStatus[it.status];
                }
              });
            });
            this.computers = computers;
            setTimeout(() => {
              this.computers.forEach((it) => {
                // let url = `/static/bigScreen/assets/computer_${it.status}.png`;
                // if (this.form.computerNodeType == "text") {
                //   url = `/static/bigScreen/assets/computer_${it.status}_text.png`;
                // }
                let url = "/static/bigScreen/assets/computer_free_text.png";
                this.computerDrawLayer.getChildren((node) => {
                  if (
                    node.getClassName() == "Group" &&
                    it.ip == node.attrs.name
                  ) {
                    const img = document.createElement("img");
                    img.src = url;
                    console.log("node", node);
                    if (
                      node.children &&
                      Array.isArray(node.children) &&
                      node.children.length
                    ) {
                      console.log("node.children[0].image", node.children[0]);
                      node.children[0].image(img);
                      let fillColor = "#333";
                      if (it.status == "free") {
                        fillColor = "#333";
                      } else if (it.status == "book") {
                        fillColor = "#ff9f4c";
                      } else if (it.status == "busy") {
                        fillColor = this.form.computerFillColor;
                      }
                      node.children[0].attrs.fill = fillColor;
                    }
                  }
                });
              });
            }, 599);
          }
        }
      });
    },
  },
  async mounted() {
    // 硬代码
    if(this.curStoreId == "1c85336c-25c2-11f0-96a6-67ef79deeeed"){
      window.close();
      return;
    }
    // 硬代码结束
    await this.getPar();
    await this.getScreenDetail();
    this.timer = setInterval(async () => {
      this.rollPar();
    }, 5 * 1000);
    console.log(document.body.clientWidth);

    if (!this.isMobile()) {
      console.log("手机");
      this.showMask = true;
      const clientWidth = document.body.clientWidth;
      const clientHeight = document.body.clientHeight;
      $("html").css({
        width: clientWidth + "px",
        height: clientHeight + "px",
        // overflow:"hidden",
        // width: "1920px",
        // height: "1080px",
      });
      var viewport = document.querySelector("meta[name=viewport]");
      if (window.devicePixelRatio == 1) {
        viewport.setAttribute(
          "content",
          "width=device-width,initial-scale=1, minimum-scale=1, user-scalable=yes"
        );
      } else if (window.devicePixelRatio == 2) {
        viewport.setAttribute(
          "content",
          "width=device-width,initial-scale=0.5, minimum-scale=0.5, user-scalable=yes"
        );
      } else if (window.devicePixelRatio == 3) {
        viewport.setAttribute(
          "content",
          "width=device-width,initial-scale=0.3333333333333333, minimum-scale=0.3333333333333333, user-scalable=yes"
        );
      } else {
        const scaleNum = 1 / window.devicePixelRatio;
        viewport.setAttribute(
          "content",
          `width=device-width,initial-scale=${scaleNum}, minimum-scale=${scaleNum}, user-scalable=yes`
        );
      }
      const scaleX = document.body.clientWidth / 1920;
      const scaleY = document.body.clientHeight / 1080;
      $("#app").css({
        "min-width":"initial"
      });
      $("#canvasWrap").css({
        transform: `scaleX(${scaleX}) scaleY(${scaleY})`,
      });
      $("#canvasWrap").css({
        transform:"rotate(90deg)",
        width:"100vh",
        height:"100vw"
        // "transform-origin":"top left"
      })
      // window.screen.orientation.lock("landscape").then(
      //   (success) => console.log(success),
      //   (failure) => console.log(failure)
      // );
    } else {
      const scaleX = document.body.clientWidth / 1920;
      const scaleY = document.body.clientHeight / 1080;
      $("#canvasWrap").css({
        transform: `scaleX(${scaleX}) scaleY(${scaleY})`,
      });
      this.$message({
        customClass: "success",
        message: "双击可进入全屏/退出全屏!",
      });
    }
    document.addEventListener(
      "fullscreenchange",
      () => {
        setTimeout(() => {
          const scaleX = document.body.clientWidth / 1920;
          const scaleY = document.body.clientHeight / 1080;
          // $("canvas").css({
          //   width:document.body.clientWidth+"px",
          //   height:document.body.clientHeight+"px",
          // })
          $("#canvasWrap").css({
            transform: `scaleX(${scaleX}) scaleY(${scaleY})`,
          });
        }, 250);
      },
      false
    );
  },
};
</script>
<style lang="scss" scoped>
.big-screen {
  width: 100%;
  height: 100%;
  overflow: hidden;
  overflow-y: auto;
  overflow-x: auto;
  box-sizing: border-box;
  background-color: rgb(246, 247, 251);
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  .modify-wrap {
    height: 70px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    .pcImgFile {
      opacity: 0;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      cursor: pointer;
    }
    .tip {
      width: 100%;
      text-align: center;
      color: red;
      font-weight: bold;
    }
  }
  .size {
    width: auto;
    margin-right: 20px;
    display: flex;
    align-items: center;
    .tit {
      font-size: 12px;
    }
  }
  .canvas-wrap {
    width: 1920px;
    height: 1080px;
    /* width: 1920px; */
    /* height: 1080px; */
    min-width: 1920px;
    min-height: 1080px;
    background-color: #fff;
    position: relative;
  }
  .drawer-wrap {
    width: 450px;
    height: 100%;
    overflow: hidden;
    overflow-y: auto;
    background-color: #fff;
    position: absolute;
    right: 0;
    top: 0;
    z-index: 9;
    box-shadow: 0px 0px 19px 19px rgba(0, 0, 0, 0.1);
    .inner-wrap {
      padding: 10px 20px;
      box-sizing: border-box;
      font-size: 14px;
      .tit {
        display: flex;
        height: 30px;
        align-items: center;
        justify-content: space-between;
        .close {
          color: red;
          cursor: pointer;
          font-size: 14px;
        }
      }
    }
    .drawer-cont {
      user-select: none;
      .site-img {
        display: inline-block;
        width: 33%;
        height: 32px;
        padding: 10px;
        box-sizing: border-box;
        text-align: center;
        position: relative;
        img {
          width: 32px;
          height: 32px;
          cursor: pointer;
        }
        .ip-no {
          position: absolute;
          top: 18px;
          left: 50%;
          transform: translateX(-50%);
          color: #fff;
          font-size: 12px;
          line-height: 12px;
          cursor: pointer;
        }
      }
    }
  }
  .context-menu {
    display: none;
    position: absolute;
    top: 0;
    left: 0;
    width: 60px;
    height: 30px;
    text-align: center;
    background-color: #fff;
    z-index: 10;
    line-height: 30px;
    font-size: 12px;
    user-select: none;
    .del {
      display: inline-block;
      width: 100%;
      height: 30px;
      text-align: center;
      line-height: 30px;
    }
  }
}
</style>
<style lang="scss">
.el-collapse-item {
  height: auto;
  min-height: 43px;
}
.upLoad {
  position: relative;
}
.el-collapse-item__header {
  height: auto;
  min-height: 43px;
}
.maskDebug {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
}
.fullScreen {
  position: fixed;
  top: 20px;
  right: 20px;
  display: flex;
  opacity: 0;
  width: 100px;
  height: 30px;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  color: #fff;
  background-color: #ff6060;
  cursor: pointer;
  transition: all 0.3s;
  &.show {
    opacity: 1;
  }
  &:hover {
    opacity: 1;
  }
}
</style>


// WEBPACK FOOTER //
// index.vue?209d1a26